import React, {useState} from "react";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import style from "./style";
import { ReactComponent as Cancel } from "../../../../assets/ViewLeave-images/mdi_remove.svg";
import color from "../../../../constants/color";
import { useNavigate } from "react-router-dom";
import Modal from "../../../../components/Modal";
import { formatDate } from "../../../../utils/DateFormat";

const ViewRecruitmentPage = ({permission,role,item,handleCloseRecruitment}) => {
  const navigate = useNavigate();
  const [open,setopen] = useState(false);
  const handleEditRecruitment = (id) =>{
    navigate("/dashboard/recruitment/createRecruitment",{state:{id:id,from:"Edit"}})
  }
  const handleNavigate =(item) => {
    navigate("/dashboard/createRecruitment",{state:{item}})
  }

  return (
    <>


      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Job Details</Typography>
          {permission?.recruitment?.isEdit?.role=="Admin" || role === "Admin" ?
            <Button variant="contained" color="success" sx={style.jobButton} onClick={handleNavigate}>
            Create A New Job
            </Button>:null
          }
        </Box>
       

      </Box>
       
      <Grid container>
        <Grid item xs={12} lg={7.4} sx={style.gridbioBoxs}>


          <Box sx={style.infoSection}>  
            <Typography  sx={style.bioIconText}>
              {item?.position}
            </Typography>
            <Typography sx={{...style.textPrimary,color:color.text}} >{`${item?.company[0]?.companyName}-${item?.workplace}`}</Typography>
            <Typography sx={style.textPrimary}>{`${formatDate(item?.fromDate)} - ${formatDate(item?.toDate)}`}</Typography>         

          </Box>
          
          <Box sx={style.line}></Box>


          <Box sx={style.bioBox}>
            {/* <Box sx={style.heading}>
              <Typography variant="body1" sx={style.subHeading}>
                  Job Description
              </Typography>


            </Box> */}
           
            <Box sx={style.content}>
              <Grid item xs={8} md={4}>
                <Typography sx={style.descText}>Recrurited Quantity</Typography>
               
              </Grid>
              <Grid item xs={1} >
                <Typography sx={{...style.descText,fontWeight:"500"}}>{item?.quantity ||" -"}</Typography>
               
              </Grid>
              
            </Box>
            <Box sx={style.content}>
              <Grid item xs={8} md={4}>
                <Typography sx={style.descText}>Working From</Typography>
               
              </Grid>
              <Grid item xs={1} >
                <Typography sx={{...style.descText,fontWeight:"500"}}>{item?.type ||" -"}</Typography>
               
              </Grid>
              
            </Box>
            <Box sx={style.content}>
              <Grid item xs={8} md={4}>
                <Typography sx={style.descText}>Department</Typography>
               
              </Grid>
              <Grid item xs={1} >
                <Typography sx={{...style.descText,fontWeight:"500"}}>{item?.department ||" -"}</Typography>
               
              </Grid>
              
            </Box>
            <Box sx={style.content}>
              <Grid item xs={8} md={4}>
                <Typography sx={style.descText}>Workplace</Typography>
               
              </Grid>
              <Grid item xs={1} >
                <Typography sx={{...style.descText,fontWeight:"500"}}>{item?.workplace ||" -"}</Typography>
               
              </Grid>
              
            </Box>

            <Box sx={style.content}>
              <Grid item xs={8} md={4}>
                <Typography sx={style.descText}>Starting Salary(From)</Typography>
               
              </Grid>
              <Grid item xs={1} >
                <Typography sx={{...style.descText,fontWeight:"500"}}>{item?.salaryStart ||" -"}</Typography>
               
              </Grid>
              
            </Box>
            <Box sx={style.content}>
              <Grid item xs={8} md={4}>
                <Typography sx={style.descText}>Starting Salary(To)</Typography>
               
              </Grid>
              <Grid item xs={1} >
                <Typography sx={{...style.descText,fontWeight:"500"}}> {item?.salaryEnd ||" -"}</Typography>
               
              </Grid>
              
            </Box>
            
            
            <Box sx={style.contactSection}>
              <Typography  sx={style.contactSubheading}>
                  Reason For Recruiment
              </Typography>
              <Typography  sx={style.detailText}>
                {item?.reason}
              </Typography>
            </Box>
            <Box sx={style.contactSection}>
              <Typography sx={style.contactSubheading}>
                 Job Description
              </Typography>
              <Typography sx={style.detailText}>
                {item?.desc}
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} lg={4.3}>
          <Box sx={style.gridbioBox}>
            <Box sx={style.infoBox}>

              <Box>
                <Typography variant="body1" sx={style.bioText}>
                  Views:
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.views}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.infoBox}>

              <Box>
                <Typography variant="body1" sx={style.bioText}>
                  Candiates:
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {item?.candidates}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.infoBox}>

              <Box>
                <Typography variant="body1" sx={style.bioText}>
                  Status:
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" sx={style.bioTextValueSuccess}>
                  {item?.status}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.infoBox}>

              <Box>
                <Typography variant="body1" sx={style.bioText}>
                  Created:
                </Typography>
              </Box>
              <Box>
                <Typography variant="body1" sx={style.bioTextValue}>
                  {formatDate(item?.createdAt)}
                </Typography>
              </Box>
            </Box>
            <Box sx={style.removeSection}>
              {permission?.recruitment?.isEdit?.role==="Admin" || role === "Admin" ? 
                <><Box>
                  <Typography variant="body1" sx={style.closeJob}>
                    Close Job
                  </Typography>
                </Box><Box>
                  <Cancel onClick={() => { setopen(true)}}/>
                </Box></>:null}
            </Box>
          </Box>
          
          <Box sx={style.createJob}>
            {permission?.recruitment?.isEdit?.role==="Admin" || role === "Admin" ?
              <Button variant="contained" color="success" sx={style.jobButtons} onClick={() => handleEditRecruitment(item?._id)}>
              Edit Job
              </Button>:null
            }
          </Box>

        </Grid>
      </Grid>
      <Modal open={open} setOpen={setopen} deletetText={"Close"} cancelText={"Cancel"} title={"Close Job"} handleDelete={() => handleCloseRecruitment(item?._id)}>
        <Box>
          <Typography>Are you sure you want to Close job?</Typography>

        </Box>
      </Modal>

    </>
  )
}
export default ViewRecruitmentPage;
